import { render, staticRenderFns } from "./TextureAdd.vue?vue&type=template&id=465f5bba&"
import script from "./TextureAdd.vue?vue&type=script&lang=js&"
export * from "./TextureAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports